import React from 'react'
import { QuestionInputProps } from '../../questionTypes'

export const MultipleChoiceQuestion: React.FC<QuestionInputProps> = ({ question, value, onChange, readOnly = false }) => (
  <div className='survey-response-question__choices'>
    {question.options.map((opt, i) => {
      const isSelected = value === opt
      return (
        <label
          key={i}
          className={['survey-response-question__choice', isSelected && 'is-selected'].filter(Boolean).join(' ')}
        >
          <span className='survey-response-question__choice-radio'>
            <span
              className={['survey-response-question__choice-dot', isSelected && 'is-active'].filter(Boolean).join(' ')}
            />
          </span>
          <input
            type='radio'
            name={`question-${question.id ?? ''}`}
            value={opt}
            checked={isSelected}
            onChange={() => onChange(opt)}
            className='survey-response-question__choice-input'
            disabled={readOnly}
          />
          <span className='survey-response-question__choice-text'>{opt}</span>
          {isSelected && (
            <svg className='survey-response-question__choice-check' viewBox='0 0 20 20' fill='currentColor'>
              <path
                fillRule='evenodd'
                d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
                clipRule='evenodd'
              />
            </svg>
          )}
        </label>
      )
    })}
  </div>
)
